
define('jst!tooltips/_contact_list',['underscore','translate'],function () { var _ = require('underscore');
var t = require('translate');
return _.template('<ol class="tooltip-list">\n<% _.each(data, function(contact) { %>\n  <li>\n    <%= contact.name %>\n    <%- presenceDot(contact.presenceState) %>\n  </li>\n<% }) %>\n</ol>\n');
 });

